import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiInstagram, FiFacebook, FiTwitter } from 'react-icons/fi';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Column 1: Brand Info */}
            <div className="footer-section footer-brand">
              <div className="footer-logo">
                <img src="/emblem-header.png" alt="Ceedees Electricals" />
                <div className="footer-logo-text">
                  <span className="logo-title">CEEDEES</span>
                  <span className="logo-subtitle">ELECTRICALS</span>
                </div>
              </div>
              <p className="section-desc">
                Your trusted electrical store in Thrissur, Kerala. Delivering quality products and professional service since 1981.
              </p>
              <div className="trust-badges">
                <span className="badge-item">GST Registered</span>
                <span className="badge-item">ISI Certified</span>
                <span className="badge-item">40+ Years</span>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="footer-section">
              <h5 className="footer-heading">Quick Links</h5>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/shop">Shop</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Column 3: Legal */}
            <div className="footer-section">
              <h5 className="footer-heading">Legal</h5>
              <ul className="footer-links">
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/refund">Refund Policy</Link></li>
                <li><Link to="/shipping">Shipping Policy</Link></li>
              </ul>
            </div>

            {/* Column 4: Contact */}
            <div className="footer-section">
              <h5 className="footer-heading">Get in Touch</h5>
              <div className="contact-info">
                <div className="contact-item">
                  <FiPhone className="contact-icon" />
                  <div>
                    <a href="tel:+919447672888">+91 94476 72888</a>
                    <br />
                    <a href="tel:+919446722433">+91 94467 22433</a>
                  </div>
                </div>
                <div className="contact-item">
                  <FiMail className="contact-icon" />
                  <div>
                    <a href="mailto:info@ceedeeselectricals.in">info@ceedeeselectricals.in</a>
                  </div>
                </div>
                <div className="contact-item">
                  <FiMapPin className="contact-icon" />
                  <div>
                    <a href="https://maps.app.goo.gl/Wp3NhKAGLpSMdtKi8" target="_blank" rel="noopener noreferrer">
                      Thrissur, Kerala
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Column 5: Map */}
            <div className="footer-section footer-map-section">
              <h5 className="footer-heading">Visit Our Store</h5>
              <div className="footer-map-wrapper">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3910.2877419627876!2d76.24152761532693!3d10.523627492419405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7ea99dfffff6d%3A0xf00ef62e9af a18d!2sCeedees%20Electricals!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ceedees Electricals Location"
                ></iframe>
              </div>
              <a
                href="https://maps.app.goo.gl/Wp3NhKAGLpSMdtKi8"
                target="_blank"
                rel="noopener noreferrer"
                className="map-link"
              >
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>
            &copy; {currentYear} Ceedees Electricals. All rights reserved.
          </p>
          <div className="footer-bottom-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" title="Facebook">
              <FiFacebook />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" title="Instagram">
              <FiInstagram />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" title="Twitter">
              <FiTwitter />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
